import { render, staticRenderFns } from "./UserMgmt.vue?vue&type=template&id=d37c98ac&scoped=true&"
import script from "./UserMgmt.vue?vue&type=script&lang=js&"
export * from "./UserMgmt.vue?vue&type=script&lang=js&"
import style0 from "./UserMgmt.vue?vue&type=style&index=0&id=d37c98ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37c98ac",
  null
  
)

export default component.exports